import { useMutation, useQueryClient } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { MatchExpenseRequestDto } from '@/features/dashboard/expenses/types/PayExpenseRequest.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';
import { toast } from 'sonner';

interface MatchExpenseParams {
  expenseId: string;
  request: MatchExpenseRequestDto;
}

export default function useMatchExpenseToBankTransaction(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ expenseId, request }: MatchExpenseParams) =>
      expensesApi.matchToBankTransaction(tourId, expenseId, request),
    onSuccess: () => {
      invalidateFinanceRelatedQueries(queryClient);
      toast.success('Wydatek został dopasowany do transakcji bankowej');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas dopasowywania wydatku do transakcji.',
      });
    },
  });
}
